import { render, staticRenderFns } from "./date-input.vue?vue&type=template&id=d83f6a30&"
import script from "./date-input.vue?vue&type=script&lang=js&"
export * from "./date-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports